<app-dashboard-navbar></app-dashboard-navbar>
<div class="container-fluid p-0" >
<div class="row m-0 justify-content-between">
    <div class="p-0 shadow-sm shadow-lg dashboard">
        <app-sidebar></app-sidebar>
    </div>
    <div class="p-0 mediaQuery" style="">
        <router-outlet></router-outlet>
    </div>
</div>
</div>
<app-dashboard-footer></app-dashboard-footer>
<!-- <script>
    alert('hello')
</script> -->